<div class="container mt-4" style="min-height: calc(100vh - 300px);">
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class=" card-header">
                    <h5 class="font-medium election-title">📄 Audit Conducted</h5>
                </div>
                <div class="card-body">
                    <div class="row">
                        <form [formGroup]="targetForm" (ngSubmit)="getAuditConducted()">
                            <div class="row align-items-end">

                                <div class="col-lg-4 col-md-6 mb-2" *ngIf="this.UserDetails?.roleId == 1">
                                    <label class="form-label">Circle Office <span class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="circleOffice" (change)="GetBlock()">
                                        <option value="">--Select--</option>
                                        <option *ngFor="let circle of circlesList" [value]="circle?.iCircleId">
                                            {{ circle?.sCircleName }}
                                        </option>
                                    </select>
                                    <div *ngIf="targetForm.get('circleOffice')?.touched && targetForm.get('circleOffice')?.invalid"
                                        class="text-danger small">
                                        Circle office is required
                                    </div>
                                </div>
                                <!-- Block Office -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label">Block Office <span class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="blockOffice">
                                        <option value="" selected>--Select--</option>
                                        <option *ngFor="let block of blockList" [value]="block?.iBlockId">
                                            {{ block?.sBlockName }}
                                        </option>
                                    </select>
                                    <div *ngIf="targetForm.get('blockOffice')?.touched && targetForm.get('blockOffice')?.invalid"
                                        class="text-danger small">
                                        block Office is required
                                    </div>
                                </div>

                                <!-- Financial Year -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label">Financial/Reporting Year <span
                                            class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="financialYear">
                                        <option value="">--Select--</option>
                                        <option *ngFor="let years of financialYears" [ngValue]="years?.financialYear">
                                            {{ years?.financialYear }}
                                        </option>
                                    </select>
                                    <div *ngIf="targetForm.get('financialYear')?.touched && targetForm.get('financialYear')?.invalid"
                                        class="text-danger small">
                                        Financial year is required
                                    </div>
                                </div>

                                <!-- Submit -->
                                <div class="col-lg-12 text-end">
                                    <button type="submit" class="btn btn-primary" [disabled]="targetForm.invalid">
                                        Get Report
                                    </button>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-12">
            <div class="card">
                <div class=" card-header">
                    <div class="d-flex align-items-center justify-content-between">
                        <h5 class="font-medium m-0">📄Report</h5>
                        <button type="button" class="btn btn-primary btn-sm" data-bs-toggle="modal"
                            data-bs-target="#addAuditConductedDataModal" (click)="addData()"
                            *ngIf="showButton && (this.UserDetails?.roleId ==11 || this.UserDetails?.roleId ==13)">+ Add
                            Audit Cunducted {{currentMonth?.name}}</button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-bordered table-striped align-middle">
                            <thead class="table-primary text-center">
                                <tr>
                                    <!-- <th>ID</th> -->
                                    <th>Data Month</th>
                                    <th>Total Societies</th>
                                    <th>Financial Year</th>
                                    <th>Audited Societies</th>
                                    <th>Previous Year</th>
                                    <th>Current Year</th>
                                    <th>Total Audited</th>
                                    <th>Percentage</th>
                                    <th>As On Arrear</th>
                                    <th>Current Year Arrear</th>
                                    <th>Previous Year Arrear</th>
                                    <th>Total Arrear</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody *ngIf="auditData.length > 0;">
                                <tr *ngFor="let item of auditData">
                                    <!-- <td>{{ item.dataMonth }}</td> -->
                                    <td>{{ getMonthName(item.dataMonth) }}</td>
                                    <td>{{ item.totalSocieties }}</td>
                                    <td>{{ item.financialYear || '-' }}</td>
                                    <td>{{ item.auditedSocieties }}</td>
                                    <td>{{ item.previousYear }}</td>
                                    <td>{{ item.currentYear }}</td>
                                    <td>{{ item.total }}</td>
                                    <td>{{ item.percentage }}</td>
                                    <td>{{ item.asOnArrear }}</td>
                                    <td>{{ item.currentYearArrear }}</td>
                                    <td>{{ item.previousYearArrear }}</td>
                                    <td>{{ item.totalArrear }}</td>
                                    <td>
                                        <div class="d-flex align-items-center gap-1">
                                            <ng-container
                                                *ngIf="!item.isVerified && this.UserDetails?.roleId !==1; else verifiedBlock">
                                                <button type="button" class="btn btn-primary btn-sm"
                                                    title="Click to Edit" (click)="editRow(item)">
                                                    <i class="bi bi-pencil-square"></i>
                                                </button>
                                                <button type="button" class="btn btn-success btn-sm"
                                                    title="Click to Verify" *ngIf="this.UserDetails?.roleId ==13"
                                                    data-bs-toggle="modal" data-bs-target="#verifyConfirmModal"
                                                    (click)="setDeleteIndex(item?.id)">
                                                    <i class="bi bi-clipboard2-check"></i>
                                                </button>
                                                <button type="button" class="btn btn-danger btn-sm"
                                                    title="Click to Delete" data-bs-toggle="modal"
                                                    data-bs-target="#deleteConfirmModal"
                                                    (click)="setDeleteIndex(item?.id)">
                                                    <i class="bi bi-trash3"></i>
                                                </button>
                                            </ng-container>

                                            <!-- Verified State -->
                                            <ng-template #verifiedBlock>
                                                <button type="button" class="btn btn-primary btn-sm">
                                                    <i class="bi bi-lock"></i>
                                                </button>
                                            </ng-template>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- Delete Confirmation Modal -->
                        <div class="modal fade" id="deleteConfirmModal" tabindex="-1"
                            aria-labelledby="deleteConfirmModalLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Delete</h5>
                                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
                                    </div>
                                    <div class="modal-body">
                                        Are you sure you want to delete ?
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                                            (click)="cancelDelete()">Cancel</button>
                                        <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                                            aria-label="Close"
                                            (click)="deleteAuditConducted(deleteIndex)">Delete</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- verify Confirmation Modal -->
                        <div class="modal fade" id="verifyConfirmModal" tabindex="-1"
                            aria-labelledby="verifyConfirmModalLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Veriication</h5>
                                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
                                    </div>
                                    <div class="modal-body">
                                        Are you sure you want to Verify?
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                                            (click)="this.deleteIndex = 0;">Cancel</button>
                                        <button type="button" class="btn btn-success" data-bs-dismiss="modal"
                                            aria-label="Close"
                                            (click)="verifyAuditConducted(deleteIndex)">Verify</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>


                <!-- Modal -->
                <div class="modal fade" id="addAuditConductedDataModal" data-bs-backdrop="static"
                    data-bs-keyboard="false" tabindex="-1" aria-labelledby="addAuditConductedDataModalLabel"
                    aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl ">
                        <div class="modal-content">
                            <div class="modal-header">
                                <!-- <h1 class="modal-title fs-5" id="addAuditConductedDataModalLabel">Add Audit Conducted
                                </h1> -->
                                <div class="col-lg-12">
                                    <h4 class="font-medium">📊 Audit Conducted in the Month</h4>
                                </div>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModel()"
                                    aria-label="Close"></button>
                            </div>
                            <div class="modal-body">

                                <form [formGroup]="auditForm">
                                    <div class="row">

                                        <!-- Total Societies -->
                                        <div class="col-lg-4 col-md-6 mb-2">
                                            <label class="form-label">Total no. of Societies<sup
                                                    class="text-danger">*</sup></label>
                                            <input type="text" class="form-control" placeholder="Please Enter"
                                                formControlName="totalSocieties" maxlength="10"
                                                (keypress)="onlyNumber($event)">
                                            <div *ngIf="isInvalid('totalSocieties')" class="text-danger small">
                                                This field is required and must be a valid number (max 10 digits).
                                            </div>
                                        </div>

                                        <!-- Societies to be Audited -->
                                        <div class="col-lg-4 col-md-6 mb-3">
                                            <label class="form-label">Societies to be Audited (2025 - 2026)<sup
                                                    class="text-danger">*</sup></label>
                                            <input type="text" class="form-control" placeholder="Please Enter"
                                                formControlName="societiesToBeAudited" maxlength="10"
                                                (keypress)="onlyNumber($event)">
                                            <div *ngIf="isInvalid('societiesToBeAudited')" class="text-danger small">
                                                This field is required and must be a valid number (max 10 digits).
                                            </div>
                                        </div>

                                        <!-- Cooperative Societies Audited -->
                                        <div class="col-lg-12">
                                            <div class="card">
                                                <div class="card-header">
                                                    <h5 class="m-0">No. of Cooperative Societies Audited Up to (July)
                                                    </h5>
                                                </div>
                                                <div class="card-body">
                                                    <div class="row">

                                                        <div class="col-lg-3 col-md-6 mb-3">
                                                            <label class="form-label">Previous Year<sup
                                                                    class="text-danger">*</sup></label>
                                                            <input type="text" class="form-control"
                                                                placeholder="Please Enter"
                                                                formControlName="previousYear" maxlength="10"
                                                                (keypress)="onlyNumber($event)">
                                                            <div *ngIf="isInvalid('previousYear')"
                                                                class="text-danger small">
                                                                This field is required and must be a valid number (max
                                                                10 digits).
                                                            </div>
                                                        </div>

                                                        <div class="col-lg-3 col-md-6 mb-3">
                                                            <label class="form-label">Current Year<sup
                                                                    class="text-danger">*</sup></label>
                                                            <input type="text" class="form-control"
                                                                placeholder="Please Enter" formControlName="currentYear"
                                                                maxlength="10" (keypress)="onlyNumber($event)">
                                                            <div *ngIf="isInvalid('currentYear')"
                                                                class="text-danger small">
                                                                This field is required and must be a valid number (max
                                                                10 digits).
                                                            </div>
                                                        </div>

                                                        <div class="col-lg-3 col-md-6 mb-3">
                                                            <label class="form-label">Total<sup
                                                                    class="text-danger">*</sup></label>
                                                            <input type="text" class="form-control"
                                                                placeholder="Please Enter" formControlName="total"
                                                                maxlength="10" (keypress)="onlyNumber($event)">
                                                            <div *ngIf="isInvalid('total')" class="text-danger small">
                                                                This field is required and must be a valid number (max
                                                                10 digits).
                                                            </div>
                                                        </div>

                                                        <div class="col-lg-3 col-md-6">
                                                            <label class="form-label">Percentage (%)<sup
                                                                    class="text-danger">*</sup></label>
                                                            <input type="text" class="form-control"
                                                                placeholder="Please Enter" formControlName="percentage"
                                                                maxlength="10" (keypress)="onlyNumber($event)">
                                                            <div *ngIf="isInvalid('percentage')"
                                                                class="text-danger small">
                                                                This field is required and must be a valid number (max
                                                                10 digits).
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Arrear Details -->
                                        <div class="col-lg-12">
                                            <div class="card">
                                                <div class="card-header">
                                                    <h5 class="m-0">Arrear Details</h5>
                                                </div>
                                                <div class="card-body">
                                                    <div class="row">

                                                        <div class="col-lg-3 col-md-6 mb-3">
                                                            <label class="form-label">Arrear as on 01/04/2024<sup
                                                                    class="text-danger">*</sup></label>
                                                            <input type="text" class="form-control"
                                                                placeholder="Please Enter" formControlName="arrearAsOn"
                                                                maxlength="10" (keypress)="onlyNumber($event)">
                                                            <div *ngIf="isInvalid('arrearAsOn')"
                                                                class="text-danger small">
                                                                This field is required and must be a valid number (max
                                                                10 digits).
                                                            </div>
                                                        </div>

                                                        <div class="col-lg-3 col-md-6 mb-3">
                                                            <label class="form-label">Current Year Arrear<sup
                                                                    class="text-danger">*</sup></label>
                                                            <input type="text" class="form-control"
                                                                placeholder="Please Enter"
                                                                formControlName="currentYearArrear" maxlength="10"
                                                                (keypress)="onlyNumber($event)">
                                                            <div *ngIf="isInvalid('currentYearArrear')"
                                                                class="text-danger small">
                                                                This field is required and must be a valid number (max
                                                                10 digits).
                                                            </div>
                                                        </div>

                                                        <div class="col-lg-3 col-md-6 mb-3">
                                                            <label class="form-label">Previous Year Arrear<sup
                                                                    class="text-danger">*</sup></label>
                                                            <input type="text" class="form-control"
                                                                placeholder="Please Enter"
                                                                formControlName="previousYearArrear" maxlength="10"
                                                                (keypress)="onlyNumber($event)">
                                                            <div *ngIf="isInvalid('previousYearArrear')"
                                                                class="text-danger small">
                                                                This field is required and must be a valid number (max
                                                                10 digits).
                                                            </div>
                                                        </div>

                                                        <div class="col-lg-3 col-md-6">
                                                            <label class="form-label">Total Arrear<sup
                                                                    class="text-danger">*</sup></label>
                                                            <input type="text" class="form-control"
                                                                placeholder="Please Enter" formControlName="totalArrear"
                                                                maxlength="10" (keypress)="onlyNumber($event)">
                                                            <div *ngIf="isInvalid('totalArrear')"
                                                                class="text-danger small">
                                                                This field is required and must be a valid number (max
                                                                10 digits).
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </form>



                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                                    (click)="closeModel()">Close</button>
                                <!-- <button type="button" class="btn btn-primary" (click)="onSubmit()">Save</button> -->
                                <!-- Submit Button -->
                                <!-- <div class="col-lg-12 text-end mb-4"> -->
                                <button type="submit" class="btn btn-primary" (click)="onSubmit()">Save</button>
                                <!-- </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>